import { SvgIcon, type SvgIconProps } from '@mui/material';

import { mergeSxProps } from 'common';

export function PlaceholderAgentIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      sx={mergeSxProps(props.sx, {
        fill: 'none',
      })}
    >
      <rect width="24" height="24" rx="5" fill="#A6A6A6" />
      <path
        d="M8.5 16.5H15.5C16.0523 16.5 16.5 16.0523 16.5 15.5V8.5C16.5 7.94772 16.0523 7.5 15.5 7.5H8.5C7.94772 7.5 7.5 7.94772 7.5 8.5V15.5C7.5 16.0523 7.94772 16.5 8.5 16.5ZM8.5 16.5L14 11L16.5 13.5M11 10.25C11 10.6642 10.6642 11 10.25 11C9.83579 11 9.5 10.6642 9.5 10.25C9.5 9.83579 9.83579 9.5 10.25 9.5C10.6642 9.5 11 9.83579 11 10.25Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
